import HandledByCell from './component';
import { withHandlers, compose } from 'recompose';
import { connect } from 'react-redux';

import { openHandlingModal } from 'redux/modules/journey-handling/effects';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';
import { injectIntl } from 'react-intl';

const fields = ['handled_by'];

const enhance = compose(
  injectIntl,
  withJourneyCardSelectors,
  connect(
    (state, props) => {
      const { handled_by: handledBy } = props.selectors.getJourneyFields(
        state,
        props.journeyId,
        fields
      );
      const t = props.intl.messages.modules.journey_cells;
      return {
        handledByName: (!!handledBy && handledBy.name) || t.no_owner,
        handledById: !!handledBy && handledBy.id,
      };
    },
    { openHandlingModal }
  ),
  withHandlers({
    handleClick:
      ({ journeyId, handledById, openHandlingModal }) =>
      (e) => {
        e.stopPropagation();
        openHandlingModal({
          id: journeyId,
          handledBy: {
            id: handledById,
          },
        });
      },
  })
);

export default enhance(HandledByCell);
